module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"slogan":"The first automated interview service with a real person"}}')
  delete Component.options._Ctor
}
